import { Col, createModal, ModalProps, Typography, useModal, useToast } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import clsx from "clsx";
import Modal from "ui/common/components/feedback/Modal/Modal";

import ModalFooter from "ui/common/components/feedback/Modal/ModalFooter/ModalFooter";
import useDeleteRole from "features/roles/hooks/useDeleteRole";
import { AssignRoleRequestDto } from "ui/admins/shared/dto/assign-role-request.dto";
import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";
import { BlockAdminModalProps } from "./BlockAdminModal.types";

const BlockAdminModal = createModal<BlockAdminModalProps & ModalProps>(({ className, releaseStrategy, ...rest }) => {
    const { hideModal } = useModal();
    const translate = useTranslate();
    const queryClient = useQueryClient();
    const { showToast } = useToast();

    const { mutate: deleteRole, isLoading } = useDeleteRole({ onSuccess: handleOnSuccess });

    function handleOnSuccess() {
        queryClient.invalidateQueries(Queries.RELEASE_STRATEGY_FIND_ALL);
        showToast(translate("actionCompletedSuccessfully"), { type: "success" });
        closeModal();
    }

    function closeModal() {
        hideModal(BlockAdminModal.id);
    }

    function handleOnSubmit() {
        const payload = {
            userId: releaseStrategy.admin.id as number,
            organizationAddress: releaseStrategy.address,
            roleType: releaseStrategy.roleType,
        };
        const assignRoleRequest = AssignRoleRequestDto.create(payload);
        deleteRole(assignRoleRequest);
    }

    return (
        <Modal
            title={translate("removePermissions")}
            className={clsx("modify-movements-modal", className)}
            style={{ width: "500px", maxHeight: "none" }}
            {...rest}
        >
            <Col gap={20}>
                <Typography color="primary" variant="body2Strong">
                    {translate("adminName")}: {releaseStrategy.admin.name}
                </Typography>
                <Typography variant="body2Strong">{translate("removePermissionsModalMessage")}</Typography>
                <ModalFooter onSubmit={handleOnSubmit} mainLabel={translate("confirm")} isLoading={isLoading} onCancel={closeModal} />
            </Col>
        </Modal>
    );
});

export default BlockAdminModal;
